<template>
  <div class="position-relative">
    <b-container>
      <b-row class="p-0 m-0">
        <b-col col sm="1" class="d-none d-sm-flex p-0 flex-row">
          <b-button
              variant="link"
              @click="scrollPrev"
              class="align-self-center p-0"
          >
            <b-icon
              icon="arrow-left-circle-fill"
              font-scale="2"
          />
          </b-button>
        </b-col>
        <b-col col xs="12" sm="10" class="d-flex flex-row align-content-start overflow-hidden p-0 m-0">
          <div ref="emblaRef" class="embla">
            <div class="embla__container">
              <div
                  v-for="({ img_url, id }, index) in models"
                  :key="id"
                  class="embla__slide"
              >
                <div
                    class="btn-choice-carousel width-auto"
                    :class="selectedModel === id ? 'blue-border' : 'grey-border'"
                    @click="$emit('selected', id)"
                >
                  <b-img-lazy
                      style="border-radius: 6px;"
                      :src="img_url"
                      :alt="id"
                      class="carousel_img"
                  />
                </div>

                <b-link
                    class="link blue-color"
                    style="margin-top: 14px"
                    @click="$emit('preview', img_url)"
                >
                  {{ $t("Prévisualiser") }}
                </b-link>
              </div>
            </div>
          </div>
        </b-col>
        <b-col col sm="1" class="d-none d-sm-flex p-0 flex-row-reverse">
          <b-button
              variant="link"
              @click="scrollNext"
              class="align-self-center p-0"
          >
            <b-icon
              icon="arrow-right-circle-fill"
              font-scale="2"
            />
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import EmblaCarousel from 'embla-carousel'

export default {
  name: 'EmblaCarousel',
  props: {
    models: {
      type: Array,
      required: true
    },
    selectedModel: {
      type: String,
      required: true,
      default: "default"
    }
  },
  data() {
    return {
      emblaApi: null
    }
  },
  computed: {},
  mounted() {
    const emblaRef = this.$refs.emblaRef
    const options = { skipSnaps: true }

    this.emblaApi = EmblaCarousel(emblaRef, options)
  },
  methods: {
    scrollPrev() {
      this.emblaApi?.scrollPrev()
    },
    scrollNext() {
      this.emblaApi?.scrollNext()
    }
  }
}
</script>

<style scoped>
  .embla {
    overflow: hidden;
    max-width: 100%;
  }

  .embla__container {
    display: flex;
    max-height: 24rem;
  }

  .embla__slide {
    margin: 0 0.8rem;
  }

  .btn-choice-carousel {
    width: auto;
    height: auto;
    background: var(--white);
    color: black;
    cursor: pointer;
    border: 1px solid;
    box-sizing: border-box;
    box-shadow: 0px 4px 12px rgba(20, 85, 224, 0.14);
    border-radius: 7px;
    padding: 0;
    border-color: #f0f0f0;
  }

  .btn-choice-carousel:hover {
    background: rgba(20, 85, 224, 0.14);
    color: black;
    border-color: var(--primary);
    box-shadow: 0px 6px 16px rgba(20, 85, 224, 0.14);
  }

  .carousel_img {
    width: auto;
    height: 22rem
  }

    @media (max-width: 576px) {
      .carousel_img {
        width: 13rem;
        height: 18rem
      }
    }

    @media (min-width: 768px) {
      .carousel_img {
        width: auto;
        height: 22rem
      }
    }


</style>